const CHERRY = "https://static.prod-images.emergentagent.com/jobs/d1ab293c-7711-4c7c-9c82-fdf692c2b21b/images/ad9afd81f8942bf9b681f4e9001c19bcd6be7ed80e5b2602f0239b39bddf8897.jpeg";

// Faint cherry motif + subtle purple/green ambient glows behind everything.
export default function CherryBackdrop() {
  return (
    <div aria-hidden className="fixed inset-0 -z-10 overflow-hidden pointer-events-none bg-ink">
      {/* ambient colour glows — subtle hints of purple & green */}
      <div className="absolute -top-40 -left-40 w-[38rem] h-[38rem] rounded-full blur-[120px] opacity-[0.14] bg-[#5b2a86]" />
      <div className="absolute top-1/3 -right-48 w-[34rem] h-[34rem] rounded-full blur-[130px] opacity-[0.10] bg-[#1f5c46]" />
      <div className="absolute bottom-0 left-1/4 w-[30rem] h-[30rem] rounded-full blur-[120px] opacity-[0.10] bg-[#722F37]" />

      {/* signature "V" — the site's mark, faint gold behind everything */}
      <span aria-hidden data-testid="brand-v-watermark" className="brand-v-bg absolute -right-[4vw] top-1/2 -translate-y-1/2 text-[68vh] md:text-[92vh] opacity-[0.075] rotate-[-8deg]">V</span>
      <span aria-hidden className="brand-v-bg absolute -left-[6vw] -bottom-[8vh] text-[34vh] opacity-[0.045] rotate-[10deg]">V</span>

      {/* faint cherries (image is on black → screen blend hides the black) */}
      <img src={CHERRY} alt="" className="absolute -top-10 right-6 w-64 opacity-[0.06] blur-[1px] mix-blend-screen rotate-12" />
      <img src={CHERRY} alt="" className="absolute bottom-10 -left-8 w-72 opacity-[0.05] blur-[1px] mix-blend-screen -rotate-12" />
      <img src={CHERRY} alt="" className="absolute top-1/2 left-1/2 -translate-x-1/2 w-52 opacity-[0.04] blur-[2px] mix-blend-screen" />
    </div>
  );
}
